import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=3229f133&scoped=true&"
import script from "./BlockEditor.vue?vue&type=script&lang=js&"
export * from "./BlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditor.vue?vue&type=style&index=0&id=3229f133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3229f133",
  null
  
)

export default component.exports